<script lang="ts">
  import { fly } from 'svelte/transition';

  interface Props {
    etiqueta: string;
    alPulsar: () => void;
    deshabilitado?: boolean;
    variante?: 'inicio' | 'recorrido';
    ariaLabel?: string;
  }

  let {
    etiqueta,
    alPulsar,
    deshabilitado = false,
    variante = 'recorrido',
    ariaLabel,
  }: Props = $props();
</script>

<button
  type="button"
  class="boton"
  class:boton--inicio={variante === 'inicio'}
  onclick={alPulsar}
  disabled={deshabilitado}
  aria-label={ariaLabel ?? etiqueta}
  in:fly={{ y: 20, duration: 600 }}
>
  {etiqueta}
</button>

<style>
  .boton {
    padding: 14px 30px;
    border: 1px solid rgba(255, 235, 150, 0.35);
    background: linear-gradient(135deg, rgba(255, 243, 168, 0.12) 0%, rgba(217, 168, 92, 0.06) 100%);
    color: #fff9e6;
    font-family: var(--familia-tipografica);
    font-size: 17px;
    font-weight: 400;
    letter-spacing: 0.05em;
    border-radius: 9999px;
    box-shadow:
      0 4px 20px rgba(0, 0, 0, 0.3),
      0 0 20px rgba(255, 215, 112, 0.15),
      inset 0 1px 1px rgba(255, 255, 255, 0.25);
    transition:
      background var(--duracion-rapida),
      transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1),
      box-shadow var(--duracion-rapida);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
  }

  .boton:hover:not(:disabled) {
    background: rgba(255, 243, 168, 0.2);
    border-color: rgba(255, 235, 150, 0.6);
    transform: scale(1.04);
    box-shadow:
      0 6px 24px rgba(0, 0, 0, 0.35),
      0 0 28px rgba(255, 215, 112, 0.3);
  }

  .boton:active:not(:disabled) {
    transform: scale(0.97);
  }

  .boton:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .boton--inicio {
    font-size: 20px;
    padding: 18px 36px;
  }
</style>
